import { render, staticRenderFns } from "./ReportSKUDiscount.vue?vue&type=template&id=57833d66&"
import script from "./ReportSKUDiscount.vue?vue&type=script&lang=js&"
export * from "./ReportSKUDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports